import * as React from "react";

import {
  TagPicker,
  ITag,
  IInputProps,
  IBasePickerSuggestionsProps,
} from "@fluentui/react/lib/Pickers";
import _ from "lodash";
import {
  getJobTitle,
  getDepartment,
  getGroup,
  getCountry,
  getLocation,
} from "../../services/teamssearch.sevice";
import { useEffect } from "react";

import {
  CloseIcon,
} from "@fluentui/react-icons-northstar";
import { Button, Flex } from "@fluentui/react-northstar";
import { useDispatch, useSelector } from "react-redux";
import {
  saveFilters,
} from "../../action/actionCreators";
import { useTranslation } from "react-i18next";

const AdvancedFilter = ({ isModalOpen, showModal, filterReference }) => {
  const dispatch = useDispatch();
  const state = useSelector((data: any) => data.commonReducer);
  const filters = state.filters;
  const [jobTitleFilter, setJobTitleFilter] = React.useState([
    { key: state.filters.jobTitle, name: state.filters.jobTitle },
  ]);
  const [country, setCountryFilter] = React.useState([
    { key: state.filters.country, name: state.filters.country },
  ]);
  const [group, setGroupFilter] = React.useState([
    { key: state.filters.group, name: state.filters.group },
  ]);
  const [location, setLocationFilter] = React.useState([
    { key: state.filters.location, name: state.filters.location },
  ]);
  const [department, setDepartmentFilter] = React.useState([
    { key: state.filters.department, name: state.filters.department },
  ]);

  const { t, i18n } = useTranslation();

  useEffect(() => {
    setJobTitleFilter([
      { key: state.filters.jobTitle, name: state.filters.jobTitle },
    ]);
    setDepartmentFilter([
      { key: state.filters.department, name: state.filters.department },
    ]);
    setLocationFilter([
      { key: state.filters.location, name: state.filters.location },
    ]);
    setGroupFilter([{ key: state.filters.group, name: state.filters.group }]);
    setCountryFilter([
      { key: state.filters.country, name: state.filters.country },
    ]);
  }, [state.filters]);

  const filterJobTitle = async (filterText: string, tagList: ITag[]) => {
    // console.log("filterText", filterText);
    const jobTitle = await getJobTitle(filterText);
    if (jobTitle.status === 200) {
      return jobTitle.data.jobTitle.map((item) => ({ key: item, name: item }));
    } else {
      return [];
    }
  };

  const filterDepartment = async (filterText: string, tagList: ITag[]) => {
    // console.log("filterText", filterText);
    const jobTitle = await getDepartment(filterText);
    if (jobTitle.status === 200) {
      return jobTitle.data.department.map((item) => ({
        key: item,
        name: item,
      }));
    } else {
      return [];
    }
  };

  const filterGroup = async (filterText: string, tagList: ITag[]) => {
    // console.log("filterText", filterText);
    const jobTitle = await getGroup(filterText);
    if (jobTitle.status === 200) {
      return jobTitle.data.group.map((item) => ({ key: item, name: item }));
    } else {
      return [];
    }
  };

  const filterCountry = async (filterText: string, tagList: ITag[]) => {
    // console.log("filterText", filterText);
    const jobTitle = await getCountry(filterText);
    if (jobTitle.status === 200) {
      return jobTitle.data.country.map((item) => ({ key: item, name: item }));
    } else {
      return [];
    }
  };

  const filterLocation = async (filterText: string, tagList: ITag[]) => {
    // console.log("filterText", filterText);
    const jobTitle = await getLocation(filterText);
    if (jobTitle.status === 200) {
      return jobTitle.data.location.map((item) => ({ key: item, name: item }));
    } else {
      return [];
    }
  };

  const getJobTitleItem = (item: ITag) => item.name;
  const getCountryItem = (item: ITag) => item.name;
  const getLocationItem = (item: ITag) => item.name;
  const getGroupItem = (item: ITag) => item.name;
  const getDepartmentItem = (item: ITag) => item.name;

  const pickerSuggestionsProps: IBasePickerSuggestionsProps = {
    // suggestionsHeaderText: "Suggested tags",
    noResultsFoundText: `${t("Participants.NoResultsFoundText")}`,
  };

  const onChangeFilter = (item, type) => {
    switch (type) {
      case "jobTitle":
        // console.log("jobTitle:", item);
        setJobTitleFilter(item);
        break;

      case "country":
        // console.log("country:", item);
        setCountryFilter(item);
        break;

      case "group":
        // console.log("group:", item);
        setGroupFilter(item);
        break;

      case "department":
        // console.log("department:", item);
        setDepartmentFilter(item);
        break;

      case "location":
        // console.log("location:", item);
        setLocationFilter(item);
        break;
      default:
        break;
    }
    // console.log(jobTitleFilter, country, location, department, group);
  };

  const onApplyFilter = () => {
    dispatch(
      saveFilters({
        jobTitle:
          jobTitleFilter[0] && jobTitleFilter[0].name
            ? jobTitleFilter[0].name
            : "",
        department:
          department[0] && department[0].name ? department[0].name : "",
        location: location[0] && location[0].name ? location[0].name : "",
        country: country[0] && country[0].name ? country[0].name : "",
        group: group[0] && group[0].name ? group[0].name : "",
      })
    );
    showModal(!isModalOpen);
    filterReference();
  };

  const onClearItem = (item) => {
    switch (item) {
      case "jobTitle": {
        setJobTitleFilter([]);
        break;
      }
      case "country": {
        setCountryFilter([]);
        break;
      }
      case "group": {
        setGroupFilter([]);
        break;
      }
      case "department": {
        setDepartmentFilter([]);
        break;
      }
      case "location": {
        setLocationFilter([]);
        break;
      }
    }
  };

  const onFilterReset = () => {
    dispatch(
      saveFilters({
        jobTitle: "",
        department: "",
        location: "",
        country: "",
        group: "",
      })
    );
  };

  const inputProps: IInputProps = {
    onBlur: (ev: React.FocusEvent<HTMLInputElement>) =>
      "onBlur called",
    onFocus: (ev: React.FocusEvent<HTMLInputElement>) =>
      "onFocus called",
  };

  return (
    <div className="advanced-filter-container">
      <Flex space="between">
        <span className="filter-header">{`${t(
          "Participants.AdvancedFilter.Filters"
        )}`}</span>
        <CloseIcon
          className="close-icon"
          onClick={() => showModal(!isModalOpen)}
        />
      </Flex>
      <section>
        <div className="advanced-filter-search-field">
          <Flex space="between">
            <label htmlFor="jobTitle">{`${t(
              "Participants.AdvancedFilter.JobTitle"
            )}`}</label>
            {jobTitleFilter[0] && jobTitleFilter[0].name && (
              <label
                onClick={() => {
                  onClearItem("jobTitle");
                }}
                className="advanced-filter-field-clear"
              >
                {`${t("Participants.AdvancedFilter.Clear")}`}
              </label>
            )}
          </Flex>
          <TagPicker
            removeButtonAriaLabel="Remove Job Title"
            selectionAriaLabel="Job Title"
            onResolveSuggestions={filterJobTitle}
            getTextFromItem={getJobTitleItem}
            pickerSuggestionsProps={pickerSuggestionsProps}
            itemLimit={1}
            selectedItems={
              jobTitleFilter[0] && jobTitleFilter[0].name ? jobTitleFilter : []
            }
            onChange={(item) => {
              onChangeFilter(item, "jobTitle");
            }}
            // disabled={tagPicker}
            inputProps={{
              ...inputProps,
              id: "jobTitle",
            }}
          />
        </div>
        <div className="advanced-filter-search-field">
          <Flex space="between">
            <label htmlFor="jobTitle">{`${t(
              "Participants.AdvancedFilter.Department"
            )}`}</label>
            {department[0] && department[0].name && (
              <label
                onClick={() => {
                  onClearItem("department");
                }}
                className="advanced-filter-field-clear"
              >
                {`${t("Participants.AdvancedFilter.Clear")}`}
              </label>
            )}
          </Flex>
          <TagPicker
            removeButtonAriaLabel="Remove Department"
            selectionAriaLabel="Job Title"
            onResolveSuggestions={filterDepartment}
            getTextFromItem={getDepartmentItem}
            pickerSuggestionsProps={pickerSuggestionsProps}
            itemLimit={1}
            selectedItems={
              department[0] && department[0].name ? department : []
            }
            onChange={(item) => {
              onChangeFilter(item, "department");
            }}
            // disabled={tagPicker}
            inputProps={{
              ...inputProps,
              id: "department",
            }}
          />
        </div>
        <div className="advanced-filter-search-field">
          <Flex space="between">
            <label htmlFor="jobTitle">{`${t(
              "Participants.AdvancedFilter.Group"
            )}`}</label>
            {group[0] && group[0].name && (
              <label
                onClick={() => {
                  onClearItem("group");
                }}
                className="advanced-filter-field-clear"
              >
                {`${t("Participants.AdvancedFilter.Clear")}`}
              </label>
            )}
          </Flex>
          <TagPicker
            removeButtonAriaLabel="Remove Group"
            selectionAriaLabel="Group"
            onResolveSuggestions={filterGroup}
            getTextFromItem={getGroupItem}
            pickerSuggestionsProps={pickerSuggestionsProps}
            itemLimit={1}
            selectedItems={group[0] && group[0].name ? group : []}
            onChange={(item) => {
              onChangeFilter(item, "group");
            }}
            // disabled={tagPicker}
            inputProps={{
              ...inputProps,
              id: "group",
            }}
          />
        </div>
        <div className="advanced-filter-search-field">
          <Flex space="between">
            <label htmlFor="jobTitle">{`${t(
              "Participants.AdvancedFilter.Country"
            )}`}</label>
            {country[0] && country[0].name && (
              <label
                onClick={() => {
                  onClearItem("country");
                }}
                className="advanced-filter-field-clear"
              >
                {`${t("Participants.AdvancedFilter.Clear")}`}
              </label>
            )}
          </Flex>
          <TagPicker
            removeButtonAriaLabel="Remove Country"
            selectionAriaLabel="Country"
            onResolveSuggestions={filterCountry}
            getTextFromItem={getCountryItem}
            pickerSuggestionsProps={pickerSuggestionsProps}
            itemLimit={1}
            selectedItems={country[0] && country[0].name ? country : []}
            onChange={(item) => {
              onChangeFilter(item, "country");
            }}
            // disabled={tagPicker}
            inputProps={{
              ...inputProps,
              id: "country",
            }}
          />
        </div>
        <div className="advanced-filter-search-field">
          <Flex space="between">
            <label htmlFor="jobTitle">{`${t(
              "Participants.AdvancedFilter.Location"
            )}`}</label>
            {location[0] && location[0].name && (
              <label
                onClick={() => {
                  onClearItem("location");
                }}
                className="advanced-filter-field-clear"
              >
                {`${t("Participants.AdvancedFilter.Clear")}`}
              </label>
            )}
          </Flex>
          <TagPicker
            removeButtonAriaLabel="Remove Location"
            selectionAriaLabel="Location"
            onResolveSuggestions={filterLocation}
            getTextFromItem={getLocationItem}
            pickerSuggestionsProps={pickerSuggestionsProps}
            itemLimit={1}
            selectedItems={location[0] && location[0].name ? location : []}
            onChange={(item) => {
              onChangeFilter(item, "location");
            }}
            // disabled={tagPicker}
            inputProps={{
              ...inputProps,
              id: "location",
            }}
          />
        </div>
      </section>
      <section>
        {/* Advanced Filter Footer */}
        <div className="advanced-Filter-footer">
          <Flex hAlign="end" gap="gap.medium">
            <Button
              tinted
              iconOnly
              title={`${t("Participants.AdvancedFilter.Reset")}`}
              content={`${t("Participants.AdvancedFilter.Reset")}`}
              onClick={onFilterReset}
              className="mg-l-5 bit-pad-10"
              style={{ border: "1px #6264a7 solid" }}
              size="medium"
            />
            <Flex gap="gap.smaller">
              <Button
                primary
                size="medium"
                title={`${t("Participants.AdvancedFilter.Apply")}`}
                content={`${t("Participants.AdvancedFilter.Apply")}`}
                onClick={onApplyFilter}
              />
            </Flex>
          </Flex>
        </div>
      </section>
    </div>
  );
};

export default AdvancedFilter;
